import store from '../store/index';
import ScorePredictorService from "@/services/scorePredictorService";
import {environmentConfig} from "../config/environmentConfig";

export default async function userAuthenticate(to, from, next) {

    store.commit('setIsLoading', true);

    if (store.state.userData) {
        store.commit('setIsLoading', false);
        return next();
    }

    const token = environmentConfig.appEnv === 'production' ? await ScorePredictorService.getUserToken() : "6B838CC0-701C-11EA-B272-A7902636F4A8";

    if (token) {
        store.commit('setIsLoading', false);
        return setUserData(token, next)
    }

    const urlParams = new URLSearchParams(window.location.search);
    const encryptedMsisdn = urlParams.get('encryptedMsisdn');
    const fantasyToken = urlParams.get('fantasyToken');
    if (!encryptedMsisdn && !fantasyToken) window.open(`${environmentConfig.entryPortalHost}`, '_self');

    if (encryptedMsisdn) {
        const headerEnrichedLoginToken = await ScorePredictorService.headerEnrichedLogin(encryptedMsisdn);
        store.commit('setIsLoading', false);
        return setUserData(headerEnrichedLoginToken, next);
    } else if (fantasyToken) {
        store.commit('setIsLoading', false);
        return setUserData(fantasyToken, next);
    } else {
        store.commit('setIsLoading', false);
        return next();
    }
}

async function setUserData(token, next) {
    store.commit('setIsLoading', true);
    const msisdn = await ScorePredictorService.getUserMsisdn(token);
    const userData = await ScorePredictorService.getUserData(msisdn);
    store.commit('setToken', token);
    store.commit('setVodacomFantasyHost', `${environmentConfig.fantasyHost}?fantasyToken=${token}`);
    store.commit('setUserData', Object.assign(userData));
    await ScorePredictorService.trackLogin(userData.msisdn);
    store.commit('setIsLoading', false);
    return next();
}
